import startCase from 'lodash-es/startCase';
import toLower from 'lodash-es/toLower';


function titleCase(str){
   return startCase(toLower(str));
}

export {
  titleCase,
}
